<template>
	<div class="container">
		<!-- 新闻详情 -->
		<div class="list">
			<div class="info">
				<div class="title" v-if="$i18n.locale == 'zh'">
					{{news.title}}
				</div>
				<div class="title" v-else-if="$i18n.locale == 'en'">
					{{news.y_title}}
				</div>
				<div class="title" v-else>
					{{news.e_title}}
				</div>
			    <div class="time">
					{{news.create_time}}
				</div>
				<div class="text" v-html="news.content"  v-if="$i18n.locale == 'zh'">
				</div>
				<div class="text" v-html="news.y_content"  v-else-if="$i18n.locale == 'en'">
				</div>
				<div class="text" v-html="news.e_content"  v-else>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
        news:{},
				id:'',
			}
		},
		mounted() {
			this.id = this.$route.params.id;
			// console.log(this.$route.params.id,'1111111111')
			this.getNews()
		},
		methods: {
			getNews() {
				var that = this;
				this.$axios
					.post("/api/index/news_info", {
						id:this.id,
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.news = ret.data.data.news
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 900px;
		display: flex;
		flex-direction: column;

		.list {
			width: 900px;
			border-bottom: 1px solid #D8D8D8;
			padding-bottom: 20px;
			margin-bottom: 20px;
			// display: flex;
			// align-items: center;
			// justify-content: space-between;

			.news {
				width: 280px;
				height: 210px;
			}

			.info {
				width: 900px;
				display: flex;
				justify-content: space-between;
				flex-direction: column;

				.title {
					font-size: 20px;
					color: #333;
					font-weight: bold;
					text-align: center;
				}
				.link {
					font-size: 16px;
					color: #004098;
					display: flex;
					align-items: center;
					cursor: pointer;
				
					.el-image {
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}
				
				.text {
					font-size: 14px;
					color: #666;
				}

				.time {
					font-size: 12px;
					color: #999;
					margin-bottom: 20px;
					margin-top: 20px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/NewsCenter/detail.vue